import React, { FC } from 'react';
import { AlertInfoOutline } from 'common/components/monochrome-icons';
import { Snack, SnackButton, Typography } from 'fronton-react';
import { hideNotification } from '@navi-toolbox/ui-components';
import { t } from 'i18next';
import { alertIcon } from './styles';

export const DATA_QA_SNACK_BUTTON = 'review-form-snack-button';

type Props = {
  hideAfter: number;
  id: string;
  title: string;
  hasButton: boolean;
  message: string;
};

export const ReviewFormErrorNotification: FC<Props> = ({ id, title, hasButton, hideAfter, message }) => (
  <Snack
    autoHideTimer={hideAfter}
    key={id}
    id={id}
    header={title}
    paragraph={message}
    variant="error"
    wideButton
    icon={<AlertInfoOutline className={alertIcon} />}
  >
    <React.Fragment key=".0">
      {hasButton && (
        <SnackButton onClick={() => hideNotification(id)} data-qa={DATA_QA_SNACK_BUTTON}>
          <Typography size="body_accent" variant="s">
            {t('reviews.form.ui.good')}
          </Typography>
        </SnackButton>
      )}
    </React.Fragment>
  </Snack>
);
